<div class="custom-actions-container" #popup *ngIf="showDialog">
  <ng-container *ngIf="!evalActions">
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.referrals?.stageDetails?.length">
      {{actionsList?.referrals.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.referrals.stageName)">
      <ng-container *ngFor="let stage of actionsList?.referrals?.stageDetails">
        <kendo-menu-item *ngIf="stage?.actionName[0]" [text]="stage?.actionName[0]">
        </kendo-menu-item>
        <kendo-menu-item *ngIf="stage?.actionName.length > 1 && stage?.actionName[1]" [text]="stage?.actionName[1]">
        </kendo-menu-item>
      </ng-container>
    </kendo-menu>
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.assessments?.stageDetails?.length">
      {{actionsList?.assessments.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.assessments.stageName)">
      <ng-container *ngFor="let stage of actionsList?.assessments?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>

    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.iep?.stageDetails?.length">{{actionsList?.iep.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.iep.stageName)">
      <ng-container *ngFor="let stage of actionsList?.iep?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.placements?.stageDetails?.length">
      {{actionsList?.placements.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.placements.stageName)">
      <ng-container *ngFor="let stage of actionsList?.placements?.stageDetails">

        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
    <!-- KIP -->
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.kip?.stageDetails?.length">
      {{actionsList?.kip.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.kip.stageName)">
      <ng-container *ngFor="let stage of actionsList?.kip?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
  </ng-container>
  <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.student?.stageDetails?.length">
    {{actionsList?.student.stageName}}</p>
  <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.student.stageName)">
    <ng-container *ngFor="let stage of actionsList?.student?.stageDetails">
      <ng-container *ngIf="stage?.actionName?.length">
        <ng-container *ngFor="let actionName of stage?.actionName">
          <kendo-menu-item *ngIf="actionName" [text]="actionName">
          </kendo-menu-item>
        </ng-container>
      </ng-container>
    </ng-container>
  </kendo-menu>
  <!-- relatedServices -->
  <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.relatedService?.stageDetails?.length">
    {{actionsList?.relatedService.stageName}}</p>
  <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.relatedService.stageName)">
    <ng-container *ngFor="let stage of actionsList?.relatedService?.stageDetails">
      <ng-container *ngIf="stage?.actionName?.length">
        <ng-container *ngFor="let actionName of stage?.actionName">
          <kendo-menu-item *ngIf="actionName" [text]="actionName">
          </kendo-menu-item>
        </ng-container>
      </ng-container>
    </ng-container>
  </kendo-menu>
  <ng-container *ngIf="evalActions">
    <kendo-menu [vertical]="true" (select)="onSelect($event, 'evaluationsNested')">
      <ng-container *ngFor="let name of evalActions.actionName">
        <kendo-menu-item *ngIf="name" [text]="name">
        </kendo-menu-item>
      </ng-container>
      <ng-container *ngFor="let name of evalActions.subActionDetails">
        <ng-container *ngFor="let details of name.actionName">
          <kendo-menu-item *ngIf="details" [text]="details">
          </kendo-menu-item>
        </ng-container>
      </ng-container>
    </kendo-menu>
  </ng-container>

</div>


<div kendoDialogContainer></div>